export const enviarcheckin = {
    text1: "Envoyer le check-in",
    text2: "Envoyez un lien à vos clients pour qu'ils effectuent leur check-in avant d'arriver à l'hébergement.",
    text3: "Sélectionnez l'hébergement *",
    text4: "Saisir le nom",
    text5: "Nom du client *",
    text6: "Numéro de téléphone du client *",
    text7: "E-mail",
    text8: "E-mail du client *",
    text9: "Envoyer",
    text09: "Programmer",
    text10: "Envoi du check-in, veuillez patienter",
    text11: "Vous devez sélectionner un hébergement pour attribuer le check-in",
    text12: "Le champ du nom est obligatoire",
    text13: "Le champ du téléphone est obligatoire",
    text14: "L'e-mail est obligatoire",
    text15: "Presque terminé",
    text16: "Bonjour ",
    text17: "! Nous sommes ",
    text18: ". Nous vous envoyons ce message afin que vous puissiez effectuer votre check-in avant d'arriver dans notre hébergement, évitant ainsi d'éventuelles attentes à la réception et, surtout, la consommation inutile de papier. \n\nPour une planète plus verte !",
    text19: "Bonjour ",
    text20: "! Nous sommes ",
    text21: ". Nous vous envoyons ce message afin que vous puissiez effectuer votre check-in avant d'arriver dans notre hébergement, évitant ainsi d'éventuelles attentes à la réception et, surtout, la consommation inutile de papier. <br> <br> Pour une planète plus verte !",
    text22: "Check-in envoyé avec succès",
    text23: "Chargement ...",

    // Corrections
    p1: "Envoyer le lien de check-in",
    p2: "Créer une réservation",
    p3: "Informations sur la réservation",
    p4: "Nom du client responsable",
    p5: "Date d'arrivée",
    p6: "Date de départ",
    p7: "Nombre de clients",
    p8: "Sélectionner une chambre",
    p9: "Non spécifié",
    p10: "Sélectionner le numéro de chambre",
    p11: "Check-in en ligne",
    p12: "Prix de la réservation",
    p13: "Créer une réservation",
    p14:`Invitez maintenant votre client à procéder au check-in.`,
    p15:`Supplément`,

    p16:`Précisez la chambre`,
    p17:`Si vous sélectionnez une chambre, nous enverrons les clés associées`,
    p18:`Sélectionner une chambre`,
    p19:`Aucun résultat trouvé. Essayez un autre terme.`,
    p20:`Aucune chambre disponible.`,
    p21:`Appuyez sur Entrée pour sélectionner`,
    p22:`Sélectionné`,
    p23:`Appuyez sur Entrée pour supprimer`,
    p24:`Aucune option disponible`,
    p25: `Réservation créée avec succès.`,
    p26: `La réservation a été effectuée avec succès. Vous pouvez retourner à la page d'accueil.`,
    p27: `Invitation envoyée avec succès.`,
    p28: `Accepter`,
};
